import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './InlineList.css';

/**
 * Grid Block Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class InlineListItem extends Component {

    /**
     * Default props
     *
     * @type {{header: boolean}}
     */
    static defaultProps = {
        header: false
    };

    /**
     * Prop types
     *
     * @type {{header: shim, image: *, imageAlt: *, link: shim, text: shim}}
     */
    static propTypes = {
        header: PropTypes.bool,
        image: PropTypes.string.isRequired,
        imageAlt: PropTypes.string.isRequired,
        link: PropTypes.string,
        text: PropTypes.string
    };

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const {header, image, imageAlt, link, text} = this.props;

        return (
            <li>
                <figure>
                    <a href={link}
                       target="_blank">
                        <img src={image}
                             alt={imageAlt}/>
                    </a>
                </figure>
                {text &&
                <article>
                    {header ?
                        <h2>{text}</h2> :
                        <p>{text}</p>}
                </article>}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/inlineList/InlineListItem.jsx